import React from "react"
import "./index.scss"
import { RichText } from "prismic-reactjs"

export const Footer = ({ data }) => {

  return (
    <div className="app-footer">
      <div className="privacy-policy">
        {data && data.length && data.map((item, index) =>
          <a key={index.toString()} target="_blank"
             href={item?.link_resource?.url}>{item && item.link_title && item.link_title[0] && RichText.render(item.link_title)}</a>
        )}
      </div>
      <p>
        <small>
          <b>© 2020 Heidi, all rights reserved.</b>
        </small>
      </p>
    </div>
  )
}
